import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store, LogOut } from 'lucide-react';
import api from '../api/client';
import { useAuthStore } from '../store/auth';

export const CreateShop: React.FC = () => {
  const navigate = useNavigate();
  const { seller, refreshSeller, logout } = useAuthStore();
  const [form, setForm] = useState({ name: '', phone: '', address: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/shops/', form);
      await refreshSeller();
      navigate('/');
    } catch (err: any) {
      const data = err.response?.data || {};
      const firstField = Object.keys(data).find((k) => Array.isArray(data[k]));
      setError(firstField ? data[firstField][0] : data.error || 'Do\'kon yaratishda xato');
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-primary-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-primary-600 p-3 rounded-full">
            <Store className="w-8 h-8 text-white" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
          Do'koningizni oching
        </h1>
        <p className="text-center text-gray-600 mb-8">
          {seller.status === 'approved'
            ? 'Arizangiz tasdiqlandi. Do\'kon ma\'lumotlarini kiriting.'
            : 'Do\'kon ma\'lumotlarini kiriting.'}
        </p>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Do'kon nomi</label>
            <input
              value={form.name}
              onChange={update('name')}
              placeholder="Masalan: Amanah Toys"
              required
              autoFocus
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Telefon</label>
            <input
              value={form.phone}
              onChange={update('phone')}
              placeholder="+998 90 123 45 67"
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Manzil</label>
            <textarea
              value={form.address}
              onChange={update('address')}
              placeholder="Do'kon manzili"
              rows={2}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2"
          >
            {loading ? 'Yaratilmoqda...' : 'Do\'konni yaratish'}
          </button>
        </form>

        <button
          onClick={handleLogout}
          className="mt-6 w-full flex items-center justify-center gap-2 text-sm text-gray-500 hover:text-gray-700"
        >
          <LogOut className="w-4 h-4" /> Chiqish
        </button>
      </div>
    </div>
  );
};
